import { useState } from 'react';
import Storage from 'localStorage';
import { AddMessage } from '../../services/seenapse';

export default function useMessage() {
  const [loading, setLoading] = useState(false);

  const onSubmitMessage = ({ uid, content, callback }) => {
    setLoading(true);
    const data = {
      uid: Storage.getItem('uid'),
      session: uid,
      content,
    };
    AddMessage(data)
      .then(() => {
        callback();
      })
      .catch((error) => {
        console.error(error);
        if (error.response.status === 400) {
          if (error.response.data.errors.detail) {
            alert(error.response.data.errors.detail);
            window.location='/';
          }
        }
        if (error.response.status === 520) {
          callback(error.response.status);
        }
      })
      .finally(() => setLoading(false));
  };

  return { onSubmitMessage, submiting: loading };
}



// WEBPACK FOOTER //
// ./src/app/projects/useMessage.js